/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
  Direction,
  Margin,
  Text,
  TextSmall,
  IconRequestMoney,
  TextCaption,
  Column
} from '@scotia/canvas-react';
import styles from '../Account/AccountContent.scss';
import { ThreeColumnProductsLayout } from '../ThreeColumnProductsLayout';
import { DataProducts } from '../DataProducts';
import { DataBalance } from '../DataBalance';
import { numberFormatter } from '../../Amounts.Converter';
import { SummaryContextMenu } from '../SummaryContextMenu';
import { getAllInSession } from '@cldf/scotiaweb-customer-information';
import { MercuryGroup, MercuryZone } from "mercury-react-sdk";
import { getMercurySettings } from '../../../../../services/service.parameters';

const CONTENT_CARD_INFO = 'account-content-card-info';
const FONT_PRODUCTS = 'font-color-product';

const convertAmountToPresentationalFormat = (value, currency) =>
  currency === 'CLP'
    ? `$${numberFormatter(value)}`
    : `UF ${numberFormatter(value)}`;

const formatDate = dateCredit => {
  const [day, month, year] = dateCredit.match(/\d+/g).map(String);
  return `${month}/${year}`;
};

const preparedArray = props => {
  let array = [];
  if (props.list.personal_loans !== undefined) {
    array = props.list.personal_loans.concat(props.list.mortgage_loans);
  } else {
    array = props.list.mortgage_loans;
  }
  return array.filter(arr => arr !== undefined);
};

const isConsumerLoan = productType => productType === 'personal_loan';

const CreditContent = props => {

  const [mercuryApiUrl, setMercuryApi] = useState(undefined);
  const [mercuryRenderersUrl, setMercuryRenderersUrl] = useState(undefined);
  const [mercuryEnabled, setMercuryEnabled] = useState(undefined);

  const getSession = async () => {
    const session = await getAllInSession();
    const { mercuryApiUrl, mercuryRenderersUrl } = await getMercurySettings();
    console.log("mercuryApiUrl", mercuryApiUrl, "mercuryRendersUrls", mercuryRenderersUrl);
    setMercuryEnabled(session.TGLMER !== undefined);
    setMercuryApi(mercuryApiUrl);
    setMercuryRenderersUrl(mercuryRenderersUrl);
  };

  useEffect(() => {
      getSession();
  }, []);
  return(
  <Direction className={styles['account-content-container']}>
    <div className={styles[CONTENT_CARD_INFO]}>
      {preparedArray(props).map((loan, i) => (
        <>
          <ItemsLoans loan={loan} />
          { i == 0 && mercuryApiUrl && mercuryRenderersUrl &&
            <Margin side={'top'} xs={24} sm={24} md={24} lg={24}>
              <MercuryGroup
                apiUrl={mercuryApiUrl}
                tokenUrl={
                  "/cgi-bin/transac/dotrxajax?TMPL=/security/passport.json&intends="
                }
                renderersUrl={mercuryRenderersUrl}
                id="loans_section_sweb"
                withEventstream={false}
                tokenExpireTime={40000}
                interactionEnabled={mercuryEnabled}
                onError={(error) => console.log("Error al cargar mercury", error)}
              >
                <MercuryZone id="loans_section_sweb_1" />
              </MercuryGroup>
            </Margin>
          }
        </>
      ))}
    </div>
  </Direction>
  );
};

const ItemsLoans = props => (
  <Margin
    md={24}
    xs={6}
    sm={12}
    lg={24}
    side={'top'}
    className={styles[CONTENT_CARD_INFO]}
  >
    {props.loan.product_information.product_type === 'personal_loan' && (
      <RendererLoans
        props
        productName="Crédito de Consumo"
        productId={props.loan.product_information.display_id}
        expireDate={formatDate(props.loan.expire_date)}
        approvedAmount={convertAmountToPresentationalFormat(
          props.loan.approved_amount.amount,
          props.loan.approved_amount.currency_code
        )}
        currentBalance={convertAmountToPresentationalFormat(
          props.loan.current_balance.amount,
          props.loan.current_balance.currency_code
        )}
        titleColumnTwo="Otorgado"
        titleColumnThree="Saldo vigente"
        typeProduct={props.loan.product_information.product_type}
      />
    )}
    {props.loan.product_information.product_type === 'mortgage' && (
      <RendererLoans
        props
        productName="Crédito Hipotecario"
        productId={props.loan.product_information.display_id}
        expireDate={formatDate(props.loan.expire_date)}
        approvedAmount={convertAmountToPresentationalFormat(
          props.loan.fee_value.amount,
          props.loan.fee_value.currency_code
        )}
        currentBalance={props.loan.expire_date}
        titleColumnTwo={`Cuota ${props.loan.actual_fee} / ${
          props.loan.total_fees
        }`}
        titleColumnThree="Vencimiento"
        typeProduct={props.loan.product_information.product_type}
      />
    )}
  </Margin>
);

const RendererLoans = props => (
  <ThreeColumnProductsLayout
    renderCol1={() => (
      <div style={{ padding: 0 }}>
        <Direction type="row" className="hide--lg hide--md">
          <Column xs={6} sm={7}>
            <TextSmall className={`${styles[FONT_PRODUCTS]} `}>
              {props.productName}
            </TextSmall>
            <DataProducts
              title={<TextCaption>{props.titleColumnTwo}</TextCaption>}
              text={
                <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>
                  {props.approvedAmount}
                </TextSmall>
              }
            />
            <DataProducts
              title={<TextCaption>{props.titleColumnThree}</TextCaption>}
              text={
                <TextSmall className={`${styles[FONT_PRODUCTS]} text--medium`}>
                  {props.currentBalance}
                </TextSmall>
              }
            />
          </Column>
          <Column xs={5} sm={4}>
            <div>
              <TextCaption> {props.productId}</TextCaption>
              {props.typeProduct !== 'mortgage' && (
                <TextCaption style={{ paddingTop: '5px' }}>
                  Vence {props.expireDate}
                </TextCaption>
              )}
            </div>
          </Column>
          <Column xs={1} sm={1}>
            <div
              style={{
                display: 'flex',
                marginRight: '-20px',
                paddingLeft: '4px',
                marginTop: '-10px',
                float: 'right'
              }}
            >
              <SummaryContextMenu
                productType={props.typeProduct}
                account={props.productId}
                productName={props.productName}
              />
            </div>
          </Column>
        </Direction>
        <div className="hide--xs hide--sm">
          <DataProducts
            title={
              <div>
                <div style={{ display: 'inline-block' }}>
                  <Text className={`${styles[FONT_PRODUCTS]} text--roman`}>
                    {props.productName}
                  </Text>
                </div>
              </div>
            }
            text={<TextSmall> {props.productId}</TextSmall>}
            badge={
              props.typeProduct !== 'mortgage' && (
                <TextSmall style={{ paddingTop: '5px' }}>
                  {' '}
                  Vence {props.expireDate}
                </TextSmall>
              )
            }
            icon={<IconRequestMoney size={36} />}
          />
        </div>
      </div>
    )}
    renderCol2={() => (
      <div className="hide--xs hide--sm">
        <DataBalance
          title={<TextSmall>{props.titleColumnTwo}</TextSmall>}
          text={
            <Text className={`${styles[FONT_PRODUCTS]} text--medium`}>
              {props.approvedAmount}
            </Text>
          }
        />
      </div>
    )}
    renderCol3={() => (
      <div className="hide--xs hide--sm">
        <DataBalance
          title={
            <div>
              <div style={{ display: 'inline-block' }}>
                <TextSmall>{props.titleColumnThree}</TextSmall>
              </div>
              <div
                style={{
                  display: 'flex',
                  marginRight: '-30px',
                  paddingLeft: '4px',
                  marginTop: '-10px',
                  float: 'right'
                }}
              >
                <SummaryContextMenu
                  productType={props.typeProduct}
                  account={props.productId}
                  productName={props.productName}
                />
              </div>
            </div>
          }
          text={
            <Text className={`${styles[FONT_PRODUCTS]} text--medium`}>
              {props.currentBalance}
            </Text>
          }
        />
      </div>
    )}
    column1={4}
    column2={4}
    column3={4}
  />
);

export default CreditContent;
